import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { getMockTestCases, getMockWorkItem } from '../../data/mock-testhub-data';
import { TestCase } from '../../models/test-case';
import { WorkItem } from '../../models/work-item';
import { UtilityService } from '../utility/utility.service';

@Injectable({
  providedIn: 'root',
})
export class TestCaseService {
  private utilityService = inject(UtilityService);

  testCaseEndpoint = `${environment.testHubApiUrl}/v1/TestCase`;

  getByTestPlanId(testPlanId: number): Observable<TestCase[]> {
    if (environment.useMockData) return of(getMockTestCases(testPlanId));
    return this.utilityService.getRequest<TestCase[]>(`${this.testCaseEndpoint}/${testPlanId}`);
  }

  getAzureDetailsById(testPlanAzureId: number): Observable<WorkItem> {
    if (environment.useMockData) return of(getMockWorkItem(testPlanAzureId));
    return this.utilityService.getRequest<WorkItem>(
      `${this.testCaseEndpoint}/GetAzureDetailsById/${testPlanAzureId}`,
    );
  }

  /** Record a skip during execution (audit-only; PBI 55100). */
  skip(testCaseId: number, userId: number): Observable<TestCase> {
    if (environment.useMockData) return of({} as TestCase);
    return this.utilityService.postRequest<TestCase>(
      `${this.testCaseEndpoint}/${testCaseId}/Skip/${userId}`,
      {},
    );
  }
}
